"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileInput = void 0;
const react_1 = __importStar(require("react"));
const public_1 = require("../../common/public");
const controls_1 = require("./..");
const FileInput_styles_1 = require("./FileInput.styles");
const defaultTextValueFormatter_1 = require("./helpres/defaultTextValueFormatter");
const InputControl_1 = require("../helpers/InputControl");
const LinkButton_1 = require("../LinkButton");
const helpers_1 = require("../../helpers");
const icons_1 = require("../../icons");
const StackView_1 = require("../../StackView");
exports.FileInput = (0, helpers_1.createUIElement)('FileInput', (_a, ref) => {
    var { className, hideInput = false, disabled = false, error = false, size = public_1.CONTROL_SIZE.m, placeholder = 'Select file', iconSrc = react_1.default.createElement(icons_1.FolderClosedIcon, null), buttonText = 'Browse...', accept, multiple = false, onChange, formatTextValue = defaultTextValueFormatter_1.defaultTextValueFormatter, value, onButtonClick, onFocus, onBlur, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: dataSelectorId } = _a, rest = __rest(_a, ["className", "hideInput", "disabled", "error", "size", "placeholder", "iconSrc", "buttonText", "accept", "multiple", "onChange", "formatTextValue", "value", "onButtonClick", "onFocus", "onBlur", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const preventBlur = (0, react_1.useRef)(false);
    const fileValueState = (0, helpers_1.useStateValue)(value, [value]);
    const fileInputRef = (0, react_1.useRef)(null);
    const inputRef = (0, react_1.useRef)(null);
    const handleClick = (0, react_1.useCallback)(() => {
        var _a;
        preventBlur.current = true;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
        onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick();
    }, [onButtonClick]);
    const handleChangeValue = (0, react_1.useCallback)((e) => {
        const files = e.target.files;
        onChange === null || onChange === void 0 ? void 0 : onChange(files);
        fileValueState.setValue(files);
    }, [fileValueState, onChange]);
    const handleLinkButtonKeyDown = (0, react_1.useCallback)((e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            handleClick();
        }
    }, [handleClick]);
    const handleLinkButtonOnBlur = (0, react_1.useCallback)((e) => {
        if (preventBlur.current) {
            preventBlur.current = false;
            return;
        }
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    }, [onBlur]);
    return (react_1.default.createElement(StackView_1.StackView, Object.assign({}, (0, helpers_1.clearProps)(rest), { ref: ref, style: style, "data-selector-id": dataSelectorId, align: StackView_1.STACK_ALIGN.center, gap: StackView_1.STACK_GAP.m, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-FileInput', className) }),
        !hideInput && (react_1.default.createElement(FileInput_styles_1.StyledFileInputBox, { tabIndex: -1, size: size, isDisabled: disabled, hasError: error },
            react_1.default.createElement(InputControl_1.InputControl, { ref: inputRef, tabIndex: -1, "data-selector-id": "input-control", value: formatTextValue(fileValueState.getValue()), placeholder: placeholder, disabled: disabled, type: controls_1.INPUT_TYPE.text, readOnly: true }))),
        react_1.default.createElement(LinkButton_1.LinkButton, { "data-selector-id": "select-link", disabled: disabled, onClick: handleClick, iconBefore: iconSrc, error: hideInput && error, onKeyDown: handleLinkButtonKeyDown, onFocus: onFocus, onBlur: handleLinkButtonOnBlur }, buttonText),
        react_1.default.createElement("input", { 
            /* key as a random number is required to constantly recreate during rendering */
            ref: fileInputRef, key: Math.random().toString(16), "data-selector-id": "native-file-input", type: "file", disabled: disabled, multiple: multiple, onChange: handleChangeValue, accept: accept, hidden: true })));
});
//# sourceMappingURL=FileInput.js.map